export const isNumber = (x: any): x is number => (typeof x === "number")